<template>
  <div v-if="itemsToShow.length > 0" class="news-module" data-cy="news-module">
    <header class="news-module__header" data-cy="news-module-title">
      <font-awesome-icon icon="fa-solid fa-bullhorn" /> OUDirect News & Features
    </header>
    <div
      v-for="(item, ind) in itemsToShow"
      class="news-module__item"
      :key="ind"
      data-cy="news-module-item"
    >
      <span class="news-module__item-title" data-cy="news-module-item-title"> {{ item.Text }} </span>

      <a
        v-if="item.HyperLink"
        :href="item.HyperLink"
        class="news-module__item-link"
        data-cy="news-module-item-link"
        ><font-awesome-icon icon="fa-solid fa-share" />{{
          item.HyperLinkText
        }}</a
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from "vue";
import type { NewsItem } from "@/Domain/NewsItem";
import { handleResponsePromiseAsync } from "@/shared/helpers/apiHelper";
import { api } from "@/api";
import { useMainStore } from "@/stores/useMainStore";

const main = useMainStore();

const items = ref<NewsItem[]>([]);

// Remove items not marked to be viewed by all viewers 
// if user is not a company or emulating a company
const itemsToShow = computed(() => {
  if (!main.companySummary) return items.value.filter((i) => i.Scope === "All");
  return items.value;
});

const getNewsItemsAsync = async () => {
  return handleResponsePromiseAsync(
    api.get("GetNewsItems", {}),
    (data) => {
      items.value = data;
    },
    "SummaryModule.vue",
    "getNewsItemsAsync"
  );
};

onBeforeMount(async () => {
  await getNewsItemsAsync();
});
</script>

<style scoped lang="scss">
.news-module {
  &__header {
    display: block;
    font-weight: 600;
    margin-bottom: 10px;
    color: #337ab7;
    font-size: 14px;
  }

  &__item {
    padding: 10px;
    margin-bottom: 8px;
    border-radius: 0 4px 4px 0;
    display: flex;
    background: white;
    border-left: 3px solid #35b189;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    &:hover {
      background: #f5f5f5;
    }

    &-title {
      font-weight: bold;
    }

    &-link {
      color: #399cd3;
      text-decoration: none;
      margin-left: auto;
    }
  }
}
</style>
